// extracted by mini-css-extract-plugin
module.exports = {"error":"form_error__3C1IQ","button":"form_button__UQMyT"};